export const ADD_CONCURRENT_USER = 'AddConcurrentUser';
export const REMOVE_CONCURRENT_USER = 'RemoveConcurrentUser';
export const SET_HUB_CONNECTION = 'SetHubConnection';
export const SET_AP_POSTING_PROGRESS = 'SetApPostingProgress';
export const SET_DISPLAY_CONCURRENT_USERS = 'SetDisplayConcurrentUsers';
export const SET_CONCURRENT_USERS = 'SetConcurrentUsers';
export const SET_HUB_READY = 'SetHubReady';
export const ADD_GROUP_LOCK = 'AddGroupLock';
export const REMOVE_GROUP_LOCK = 'RemoveGroupLock';
export const SET_GROUP_LOCK = 'SetGroupUsers';
export const SET_GROUP_LOCK_ENABLED = 'SetLockEnabled';
export const SET_GROUP_NAME = 'SetGroupName';
export const REMOVE_TOAST = 'RemoveToast';
export const ADD_TOAST = 'AddToast';

